import moment from 'moment-timezone'
import { dateToString } from 'utils/dateTime'
import { PortfolioBenchmark } from 'utils/constants'
import { captureEvent } from './index'
import { ProductEvents } from './constants'

const describePeriod = (companyTimeZone, period) => {
  if (!period?.from || !period?.to) {
    return { interval: 'default', days: null }
  }

  const from = moment.tz(period.from, companyTimeZone)
  const to = moment.tz(period.to, companyTimeZone)

  return {
    interval: `${dateToString(companyTimeZone, period.from)}/${dateToString(
      companyTimeZone,
      period.to
    )}`,
    days: to.diff(from, 'days') + 1,
  }
}

const dashboardNameForTab = tab => tab.toLowerCase()

const analyticsDashboardName = (activeTab, isEdgeDataPro) =>
  isEdgeDataPro && activeTab !== PortfolioBenchmark
    ? null
    : dashboardNameForTab(activeTab)

const capturePriceChangeSubmitted = stationResponses => {
  const accepted = stationResponses.filter(({ error }) => !error)
  if (accepted.length === 0) {
    return
  }

  const fuelGradeIds = accepted.flatMap(({ polePriceChangeRequests }) =>
    polePriceChangeRequests.map(({ fuelGradeId }) => fuelGradeId)
  )

  captureEvent(ProductEvents.PRICE_CHANGE_SUBMITTED, {
    site_count: accepted.length,
    grade_count: new Set(fuelGradeIds).size,
    source: 'manual',
  })
}

const captureReportExported = (
  reportName,
  companyTimeZone,
  period,
  exportType
) => {
  const { interval, days } = describePeriod(companyTimeZone, period)

  captureEvent(ProductEvents.REPORT_EXPORTED, {
    report_name: reportName,
    format: 'csv',
    period: interval,
    period_days: days,
    ...(exportType && { export_type: exportType }),
  })
}

const captureDashboardViewed = (dashboardName, companyTimeZone, period) => {
  const { interval, days } = describePeriod(companyTimeZone, period)

  captureEvent(ProductEvents.DASHBOARD_VIEWED, {
    dashboard_name: dashboardName,
    period_selected: interval,
    period_days: days,
  })
}

const captureAlertOpened = alertType => {
  captureEvent(ProductEvents.ALERT_OPENED, { alert_type: alertType })
}

const captureFilterApplied = filterType => {
  captureEvent(ProductEvents.FILTER_APPLIED, { filter_type: filterType })
}

export {
  analyticsDashboardName,
  captureAlertOpened,
  captureDashboardViewed,
  captureFilterApplied,
  capturePriceChangeSubmitted,
  captureReportExported,
  dashboardNameForTab,
}
